import KpiPage from './KpiPage';

const AcquisitionPage = (props) => {
    const year = 2022; // Example year
    const pageId = 15; // Example page ID


    return (
        <KpiPage year={year} pageId={pageId} pageIdentifier={props.pageIdentifier} />
    );
};

export default AcquisitionPage;